import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { translations } from '@/data/translations';
import { useCategories } from '@/hooks/useSupabase';
import { Skeleton } from '@/components/ui/skeleton';

export function CategoryFilter() {
  const { t, getLocalizedField } = useLanguage();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCategory = searchParams.get('category');
  
  const { categories, loading } = useCategories();

  const handleCategoryClick = (slug) => {
    if (slug === null) {
      searchParams.delete('category');
    } else {
      searchParams.set('category', slug);
    }
    setSearchParams(searchParams);
  };

  if (loading) {
    return (
      <div className="flex flex-wrap gap-3" data-testid="category-filter-loading">
        {[...Array(7)].map((_, i) => (
          <Skeleton key={i} className="h-10 w-24 rounded-full bg-[#E5E5E5]" />
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-3" data-testid="category-filter">
      <button
        onClick={() => handleCategoryClick(null)}
        className={`font-sans text-sm uppercase tracking-widest px-4 py-2 rounded-full border transition-colors ${
          !activeCategory
            ? 'bg-[#2C2C2C] text-white border-[#2C2C2C]'
            : 'bg-transparent text-[#2C2C2C] border-[#E5E5E5] hover:border-[#2C2C2C]'
        }`}
        data-testid="filter-all"
      >
        {t(translations.catalog.allCategories)}
      </button>
      {categories.map((category) => (
        <button
          key={category.slug}
          onClick={() => handleCategoryClick(category.slug)}
          className={`font-sans text-sm uppercase tracking-widest px-4 py-2 rounded-full border transition-colors ${
            activeCategory === category.slug
              ? 'bg-[#2C2C2C] text-white border-[#2C2C2C]'
              : 'bg-transparent text-[#2C2C2C] border-[#E5E5E5] hover:border-[#2C2C2C]'
          }`}
          data-testid={`filter-${category.slug}`}
        >
          {getLocalizedField(category, 'name')}
        </button>
      ))}
    </div>
  );
}
